import { Injectable } from '@angular/core';
import { ApiAuthService } from './api-auth.service';
import { ToTypeOrm } from '../models/_to-type-orm.schema';

@Injectable({
  providedIn: 'root'
})
export class CustomPaymentsAuthService extends ApiAuthService {

  private readonly url = `${this.baseUrl}/custom-payments`;

  async getAllSalePayments(page?: number, limit?: number, order?: {}, filter?: { [key: string]: ToTypeOrm }): Promise<{customSalePayments: any[], count: number}> {
    let params = {};
    if (page) params['page'] = page;
    if (limit) params['limit'] = limit;
    if (order) params['order'] = JSON.stringify(order);
    if (filter) params['filter'] = JSON.stringify(filter);
    return this.request(() => 
      this.http.get<any>(`${this.url}`, { params: params }).toPromise()
    );
  }
}
